import { addParamsToUrl } from 'js/utils/url.util';

export const getDynamicImageUrl = (dynamicImageUrl: string, timestamp: string): string => {
    try {
        const url = new window.URL(dynamicImageUrl);

        return addParamsToUrl({ t: timestamp }, url.href);
    } catch {
        return '';
    }
};
